<template>
    <nav class="navbar"><slot></slot></nav>
</template>
